import {MouseEvent, useCallback, useState} from 'react';

export function useIndeterminateCheckbox<T extends {id: string}>(items: T[]) {
   const [_checked, setChecked] = useState([] as T[]);

   const toggleAll = useCallback(
      (e: MouseEvent<HTMLButtonElement>) => {
         const checked = (e.target as HTMLInputElement).checked;
         if (checked) {
            setChecked([...items]);
         } else {
            setChecked([]);
         }
      },
      [setChecked, items]
   );

   const isChecked = useCallback((item: T) => _checked.findIndex((i) => i.id === item.id) >= 0, [
      _checked,
   ]);

   const handleCheck = useCallback(
      (value: T) => () => {
         const currentIndex = _checked.findIndex((i) => i.id === value.id);
         const newChecked = [..._checked];

         if (currentIndex === -1) {
            newChecked.push(value);
         } else {
            newChecked.splice(currentIndex, 1);
         }

         setChecked(newChecked);
      },
      [_checked, setChecked]
   );

   return {
      checked: _checked.length === items.length,
      indeterminate: _checked.length !== 0 && _checked.length !== items.length,
      isChecked,
      toggleAll,
      handleCheck,
      checkedItems: _checked,
   };
}
